import type { LicensedProducts } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';

export const hasJpdLicense = (licensedProducts: LicensedProducts): boolean =>
	licensedProducts['jira-product-discovery'] === true;
